<template>
  <div>
    <h2 class="content-block-title">{{ title }}</h2>

    <!-- <div class="loading-container">
        <dx-load-indicator :height="60" :width="60" />
        <DxLoadIndicator :height="60" :width="60" />
    </div>       -->

    <dx-data-grid
        class="dx-card content-block"
        :data-source="dataSource"
        key-expr="id"
        :focused-row-index="0"
        :show-borders="false"
        :focused-row-enabled="true"
        :column-auto-width="true"
        :column-hiding-enabled="true"
        >
        <dx-paging :page-size="10" />
        <dx-pager :show-page-size-selector="true" :show-info="true" />
        <dx-filter-row :visible="true" />

        <dx-column data-field="id" caption="#" :width="50" :allow-sorting="false" />
        <dx-column data-field="site" caption="Site" />
        <dx-column data-field="State" caption="State" />

        <!-- <dx-column data-field="Health" caption="Health" /> -->
        <dx-column data-field="Health" caption="Health" cell-template="healthCellTemplate" />
        <template #healthCellTemplate="{ data }">
        <span :class="['health-pill', data.value.toLowerCase()]">
            {{ data.value }}
        </span>
        </template>

    </dx-data-grid>
        <div v-if="loading" class="loading-overlay">
            <DxLoadIndicator :height="60" :width="60" />
        </div>    
    </div>
    
</template>

<script setup>
    import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
    import { ref, onMounted } from 'vue';
    import DxDataGrid, {
        DxColumn,
        DxFilterRow,
        DxPager,
        DxPaging
    } from 'devextreme-vue/data-grid';
    import axios from 'axios';

    const title = 'WordPress Site Snapshots';
    const dataSource = ref([]);
    const loading = ref(true);
    // const error = ref(null);

    onMounted(async () => {
        loading.value = true;
        try {
            const response = await axios.get('/internal/wordpress/site-snapshots');
            const rawSites = response.data.sites || [];

            dataSource.value = rawSites.map((item, index) => ({
            id: index + 1,
            ...item
            }));
        } catch (error) {
            console.error('Failed to load site snapshots:', error);
        } finally {
            loading.value = false;
        }
    });
</script>


<style lang="scss">
    .dx-datagrid-filter-row {
        background-color: transparent;
    }
    // .loading-container {
    //     display: flex;
    //     justify-content: center;
    //     align-items: center;
    //     // height: 600px;
    //     // width: 100%;
    // }  

    .loading-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        // background-color: rgba(255, 255, 255, 0.6); // optional: light overlay
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    }    
    .health-pill {
        display: inline-block;
        padding: 2px 10px;
        border-radius: 12px;
        font-weight: 500;
        font-size: 0.85em;
        color: white;
        text-transform: capitalize;
    }

    .health-pill.healthy {
        background-color: #28a745; // green
    }

    .health-pill.unhealthy {
        background-color: #dc3545; // red
    }

    .health-pill.unknown {
        background-color: #6c757d; // gray
    }
</style>